/**
 * Most pages are a fixed-height shell (base.html): the body fills the window
 * and only <main> scrolls. Android's installed app can start with 100dvh
 * taller than the screen, cutting off the bottom of the page, so the body is
 * sized to the measured window height instead and re-measured as it changes.
 */
const ROOT = document.documentElement
let height = null

const update = () => {
    // iOS shrinks innerHeight while pinch-zoomed, which isn't a new window size
    if (window.visualViewport && window.visualViewport.scale !== 1) return
    if (window.innerHeight === height) return
    height = window.innerHeight
    ROOT.style.setProperty('--app-height', `${height}px`)
}

update()
window.addEventListener('resize', update)
window.addEventListener('pageshow', update)
window.visualViewport?.addEventListener('resize', update)
// Android's cold start doesn't always fire a resize once the window settles
;[250, 1000].forEach((ms) => setTimeout(update, ms))
